import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { DashboardModuleListItem, Image } from '@domain-group/suit-theme'
import { faUsers } from '@fortawesome/pro-light-svg-icons'

import useAgencySelector from '@hooks/useAgencySelector'
import { generateUrls, useRelations } from '@hooks/useTeam'

import { formatEntityCount } from '@functions/entity'

import type { TeamModel } from '@models/types'

import placeholderImageUrl from '../../assets/teams-placeholder.png'

const TeamListItem = (props: { team: TeamModel }) => {
  const { team } = props
  const { default: defaultTeam, team_member_count, title } = team || {}

  const { selectedAgencyId } = useAgencySelector()
  const { editTeamUrl } = generateUrls(team, { prefixRoute: `agencies/${selectedAgencyId}/manage` })

  const { coverImage, leadAgent } = useRelations(team)

  // @ts-expect-error TS2339
  const { original_url } = coverImage || {}

  return (
    <DashboardModuleListItem
      href={editTeamUrl}
      imageComponent={(
        <Image
          backgroundSize="cover"
          borderRadius={5}
          boxProps={{ border: '1px solid', borderColor: 'lineColor' }}
          placeholderUrl={placeholderImageUrl}
          url={original_url}
        />
      )}
      secondaryText={(
        <>
          <FontAwesomeIcon icon={faUsers} />
          {/*
           // @ts-expect-error TS2322 */}
          {` ${formatEntityCount({ entityCount: team_member_count, entityString: 'Member' })}`}
        </>
    )}
      title={title}
    >
      {defaultTeam && (
        // @ts-expect-error TS2339
        <DashboardModuleListItem.TertiaryText>
          {/*
           // @ts-expect-error TS2339 */}
          {`Default for ${leadAgent?.full_name}`}
          {/*
         // @ts-expect-error TS2339 */}
        </DashboardModuleListItem.TertiaryText>
      )}

    </DashboardModuleListItem>
  )
}

export default TeamListItem
